import {
  Button,
  Dialog,
  DialogContent,
  DialogTitle,
  Divider,
  IconButton,
  Typography,
} from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';
import { useStyles } from '../styles';
import { getSafeUrl } from '../../../utils/Utils';

const MappedAssetsPopup = ({ data, open, onClose }: any) => {
  const classes = useStyles();
  const previewLink = getSafeUrl(data?.previewLink);
  const downloadLink = getSafeUrl(data?.downloadLink);

  if (!previewLink) {
    return (
      <Dialog open={open} onClose={onClose} fullWidth maxWidth="lg">
        <div className={classes.popupTitle}>
          <DialogTitle>
            <span>Mapped Assets</span>
          </DialogTitle>
          <IconButton aria-label="close" onClick={onClose}>
            <CloseIcon />
          </IconButton>
        </div>
        <Divider />
        <DialogContent className={classes.customPadding}>
          <Typography>No preview available.</Typography>
        </DialogContent>
      </Dialog>
    );
  }

  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="lg">
      <div className={classes.popupTitle}>
        <DialogTitle>
          <span>Mapped Assets</span>
        </DialogTitle>
        <div
          style={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
          }}
        >
          <Button
            variant="contained"
            color="primary"
            onClick={() => {
              console.log('Download link:', downloadLink);
              if (downloadLink) {
                const link = document.createElement('a');
                link.href = downloadLink;
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
              }
            }}
            style={{
              height: 'fit-content',
              padding: '8px',
            }}
          >
            Download
          </Button>
          <IconButton aria-label="close" onClick={onClose}>
            <CloseIcon />
          </IconButton>
        </div>
      </div>
      <Divider />
      <DialogContent className={classes.customPadding}>
        <iframe
          src={previewLink}
          title="Preview"
          style={{ width: '100%', height: '500px', border: 'none' }}
        />
      </DialogContent>
    </Dialog>
  );
};

export default MappedAssetsPopup;
